import React from 'react'
import withIcon from '@/components/withIcon'

const IconPerson = ({ className }) => {
  return (
    <svg
      className={className}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.08594 14.4395C3.08594 14.4395 2.08594 14.4395 2.08594 13.4395C2.08594 12.4395 3.08594 9.43945 8.08594 9.43945C13.0859 9.43945 14.0859 12.4395 14.0859 13.4395C14.0859 14.4395 13.0859 14.4395 13.0859 14.4395H3.08594Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08594 8.43945C9.74279 8.43945 11.0859 7.09631 11.0859 5.43945C11.0859 3.7826 9.74279 2.43945 8.08594 2.43945C6.42908 2.43945 5.08594 3.7826 5.08594 5.43945C5.08594 7.09631 6.42908 8.43945 8.08594 8.43945Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default withIcon(IconPerson)
